import React, { useState, useEffect, useRef, forwardRef, Fragment } from "react";
import { useHistory } from "react-router-dom";
import {TextField,
        Grid,
        Box,
        Button,
        CircularProgress,
        Tabs,
        Tab,
        AppBar,
        Typography,
        InputAdornment,
        NativeSelect,
        FormHelperText,
        FormControl,
        InputLabel,
        Switch,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import { useUserState } from "../../context/UserContext";
import DateFnsUtils from '@date-io/date-fns';
import useStyles from './styles';
import classnames from "classnames";
import ttAPI from '../../api/ttAPI';
import Widget from '../../components/Widget';
import { toast } from 'react-toastify'
import Notification from "../../components/Notification";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import config from '../../config';

import JobDetails from '../../components/JobDetails/JobDetails';
import SelectTechnicians from '../../components/Technician/SelectTechnicians';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import DescriptionIcon from '@material-ui/icons/Description';
import ViewWeekIcon from '@material-ui/icons/ViewWeek';
import BuildIcon from '@material-ui/icons/Build';
import ShortTextIcon from '@material-ui/icons/ShortText';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

import './UpdateAsset.css'
import "react-datepicker/dist/react-datepicker.css";

registerLocale('en-NZ', enNZ);

const UpdateAsset = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    const { onFormUpdated, onAssetUpdated } = props

    const classes = useStyles();
    const history = useHistory();
    var { disposal_codes } = useUserState();

    const adminRoles = JSON.parse(localStorage.getItem("admin_roles"));
    const assetEditRole = adminRoles?.includes("ASSET_EDIT");

    const testedRef = useRef(null);
    const expiresRef = useRef(null);
    const disposalDateRef = useRef(null);
    const testedCalendarRef = useRef(null);
    const expiresCalendarRef = useRef(null);
    const disposalDateCalendarRef = useRef(null);

    const [asset, setAsset] = useState(props.asset);
    const [disposalCodesOptions, setDisposalCodesOptions] = useState([]);
    const [descriptionOptionsOpen, setDescriptionOptionsOpen] = React.useState(false);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const descriptionOptionsLoading = descriptionOptionsOpen && descriptionOptions.length === 0;
    const [descriptionValue, setDescriptionValue] = useState(null);
    const [descriptionInputValue, setDescriptionInputValue] = useState('');
    const [workers, setWorkers] = useState([]);
    const [selectedTested, setSelectedTested] = React.useState(null);
    const [selectedExpires, setSelectedExpires] = React.useState(null);
    const [selectedDisposalDate, setSelectedDisposalDate] = React.useState(null);


    const [testedFocused, setTestedFocused] = React.useState(false);
    const [expiresFocused, setExpiresFocused] = React.useState(false);
    const [disposalDateFocused, setDisposalDateFocused] = React.useState(false);
    const [noDisposalCodeSelectedError, setNoDisposalCodeSelectedError] = React.useState(false);
    const [selectedDisposalCodeCode, setSelectedDisposalCodeCode] = React.useState(-1);
    var currentTestedValue = null;
    var currentExpiresValue = null;
    var currentDisposalDateValue = null;

    const [isAssetImageLoaded, setIsAssetImageLoaded] = useState(false);
    const [isAssetLocationImageLoaded, setIsAssetLocationImageLoaded] = useState(false);
    const [isAssetSerialImageLoaded, setIsAssetSerialImageLoaded] = useState(false);
    const [isAssetConditionImageLoaded, setIsAssetConditionImageLoaded] = useState(false);
    const [isAssetFailedImageLoaded, setIsAssetFailedImageLoaded] = useState(false);

    const [readableResults, setReadableResults] = useState('');
    const [testerType, setTesterType] = useState(null);
    const [isFormtab, setIsFormtab] = useState(false);
    const [isReadableResultsLoaded, setIsReadableResultsLoaded] = useState(false);

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography component="div">{children}</Typography>
            </Box>
          )}
        </div>
      );
    }

    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

    useEffect(() => {
    let active = true;

    /*if (!descriptionOptionsLoading) {
      return undefined;
    }*/
    //console.log("descriptionOptionsLoading is loading....",descriptionInputValue);

    (async () => {
      const response = await ttAPI.getDescriptionsByKey(descriptionInputValue);

      if (active) {
        console.log(response);
        setDescriptionOptions(response);
      }
    })();

    return () => {
      active = false;
    };
  }, [descriptionOptionsLoading, descriptionInputValue]);

    useEffect(() => {
        if (props.asset !== null && props.asset !== undefined) {
          //fetch asset result
          (async () => {
            const response = await ttAPI.getAssetReadableResultsAndType(props.asset.id);
            setReadableResults(response !== null ? replaceNewlineToHtmlBreak(replaceTag(response[0])) : null);
            setTesterType(response[1]);
            setIsFormtab(response[2]);
            setIsReadableResultsLoaded(true);
          })();

          if (props.asset.tested !== undefined && props.asset.tested !== null && props.asset.tested !== '') {
              setSelectedTested(new Date(props.asset.tested));
          }

          if (props.asset.expires !== undefined && props.asset.expires !== null && props.asset.expires !== '') {
              setSelectedExpires(new Date(props.asset.expires));
          }

          if (props.asset.disposal_date !== undefined && props.asset.disposal_date !== null && props.asset.disposal_date !== '') {
              setSelectedDisposalDate(new Date(props.asset.disposal_date));
          }

          if (props.asset.disposal_code !== undefined && props.asset.disposal_code != null) {
              setSelectedDisposalCodeCode(props.asset.disposal_code);
          }

          if (props.asset.description !== undefined && props.asset.description != null) {
              setDescriptionValue(props.asset.description);
          }

        }
    },[props.asset]);


    useEffect(() => {
      if (asset !== undefined && asset !== null) {
        if (asset.disposed) {
            if (asset.disposal_code !== null && asset.disposal_code !== undefined &&
                asset.disposal_date !== null && asset.disposal_date !== undefined) {
                    onFormUpdated(true);
                }
                else{
                    onFormUpdated(false);
                }
        }
        else {
            onFormUpdated(true);
        }
        onAssetUpdated(asset);
      }
    }, [asset]);

    useEffect(() => {
      if (testedCalendarRef !== undefined && testedCalendarRef !== null &&
        testedCalendarRef.current !== undefined && testedCalendarRef.current !== null) {
        testedCalendarRef.current.setOpen(testedFocused);
      }
    },[testedFocused]);

    useEffect(() => {
      if (expiresCalendarRef !== undefined && expiresCalendarRef !== null &&
        expiresCalendarRef.current !== undefined && expiresCalendarRef.current !== null) {
        expiresCalendarRef.current.setOpen(expiresFocused);
      }
    },[expiresFocused]);

    useEffect(() => {
      if (disposalDateCalendarRef !== undefined && disposalDateCalendarRef !== null &&
        disposalDateCalendarRef.current !== undefined && disposalDateCalendarRef.current !== null) {
        disposalDateCalendarRef.current.setOpen(disposalDateFocused);
      }
    },[disposalDateFocused]);

    useEffect(() => {
      var tempDisposalCodes = [];
      tempDisposalCodes.push(<option key="0" aria-label="None" value="" />);
      //console.log(disposal_codes);
      if (disposal_codes !== undefined) {
          disposal_codes.map(disposalCode => {
            if (disposalCode.id) {
              tempDisposalCodes.push(<Fragment key={disposalCode.code}><option value={disposalCode.code}>{disposalCode.code} - {disposalCode.value}</option></Fragment>)
            }
            return tempDisposalCodes;
          });
      }
      setDisposalCodesOptions(tempDisposalCodes);
    }, [disposal_codes]);

    function handleChange(e) {
      setAsset({
        ...asset,
        [e.target.name]: e.target.value,
      });
    }

    function updateDescription(value) {
      setAsset({
        ...asset,
        description: value
      });
    }



    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeTested(d) {//console.log('handleChangeTested',d);
      currentTestedValue = d;
    }

    function focusTested(event) {//console.log('focusTested',event);
      setTestedFocused(true);
    }

    function blurTested(event) {//console.log('blurTested',event, currentCompleteValue);
      setTestedFocused(false);
      saveTested();
    }

    // triggered if use keyboard
    function handleTestedKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setTestedFocused(false);
        saveTested();
      }
    }

    // triggered if select a date
    function handleSelectTested(d) {
      saveTested();
    }

    function saveTested() {
      var d = currentTestedValue !== undefined && currentTestedValue !== null ? new Date(currentTestedValue) : null;
      if (d !== null) {
        let [date, month, year] = d.toLocaleDateString('en-NZ').split("/")
        setAsset({
          ...asset,
          tested: `${year}-${month}-${date}`
        });
        setSelectedTested(new Date(currentTestedValue));
        currentTestedValue = d;
      }
    }

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeExpires(d) {//console.log('handleChangeTested',d);
      currentExpiresValue = d;
    }

    function focusExpires(event) {//console.log('focusTested',event);
      setExpiresFocused(true);
    }

    function blurExpires(event) {//console.log('blurTested',event, currentCompleteValue);
      setExpiresFocused(false);
      saveExpires();
    }

    // triggered if use keyboard
    function handleExpiresKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setExpiresFocused(false);
        saveExpires();
      }
    }

    // triggered if select a date
    function handleSelectExpires(d) {
      saveExpires();
    }

    function saveExpires() {
      var d = currentExpiresValue !== undefined && currentExpiresValue !== null ? new Date(currentExpiresValue) : null;
      if (d !== null) {
        let [date, month, year] = d.toLocaleDateString('en-NZ').split("/")
        setAsset({
          ...asset,
          expires: `${year}-${month}-${date}`
        });
        setSelectedExpires(new Date(currentExpiresValue));
        currentExpiresValue = d;
      }
    }

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeDisposalDate(d) {//console.log('handleChangeTested',d);
      currentDisposalDateValue = d;
    }

    function focusDisposalDate(event) {//console.log('focusTested',event);
      setDisposalDateFocused(true);
    }

    function blurDisposalDate(event) {//console.log('blurTested',event, currentCompleteValue);
      setDisposalDateFocused(false);
      saveDisposalDate();
    }

    // triggered if use keyboard
    function handleDisposalDateKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setDisposalDateFocused(false);
        saveDisposalDate();
      }
    }

    // triggered if select a date
    function handleSelectDisposalDate(d) {
      saveDisposalDate();
    }

    function saveDisposalDate() {
      var d = currentDisposalDateValue !== undefined && currentDisposalDateValue !== null ? new Date(currentDisposalDateValue) : null;
      if (d !== null) {
        let [date, month, year] = d.toLocaleDateString('en-NZ').split("/")
        setAsset({
          ...asset,
          disposal_date: `${year}-${month}-${date}`
        });
        setSelectedDisposalDate(new Date(currentDisposalDateValue));
        currentDisposalDateValue = d;
      }
    }

    function onClickDisposedSwitch() {
        setAsset({
          ...asset,
          disposed: asset.disposed === undefined || asset.disposed === null ? false : !asset.disposed
        });
    }

    function handleChangeDisposalCode(e) {
      setAsset({
        ...asset,
        disposal_code: e.target.value,
      });
      setSelectedDisposalCodeCode(e.target.value);
    }

    function onBlurDisposalCodeSelection() {
      validateDisposalCode();
    }

    function validateDisposalCode() {
      setNoDisposalCodeSelectedError(selectedDisposalCodeCode === undefined || selectedDisposalCodeCode === null || selectedDisposalCodeCode <= 0);
    }

    function replaceNewlineToHtmlBreak(str) {
    	return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    function replaceTag(str) {
      return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

  return (asset && <>
    <div className={classes.contentDiv}>

        <Grid container spacing={4}>
          <Grid item xs={12} md={12} sm={12}>
              <div className={classes.formDisplay}>
                <TextField
                  id="location"
                  disabled={!assetEditRole}
                  label="Location"
                  autoComplete='off'
                  onChange={handleChange}
                  name="location"
                  value={asset.location || ''}
                  variant="outlined"
                  size="small"
                  style={{ marginBottom: 20 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationCityIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/*}<TextField
                  id="description"
                  label="Description"
                  autoComplete='off'
                  onChange={handleChange}
                  name="description"
                  value={asset.description || ''}
                  variant="outlined"
                  size="small"
                  style={{ marginBottom: 20 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DescriptionIcon />
                      </InputAdornment>
                    ),
                  }}
                />*/}
                <div className={classes.inline}>
                    <Autocomplete
                      disabled
                      freeSolo
                      id="description"
                      noOptionsText="Type to search"
                      options={descriptionOptions}
                      loading={descriptionOptionsLoading}
                      getOptionLabel={(option) => option.code === undefined || option.code === null ? option : `${option.code} - ${option.value}`}
                      style={{ width: 300, marginBottom: 20}}
                      getOptionSelected={(option, value) => value.id === undefined || value.id === null ? value === option.value : (option.id === value.id)}
                      onInputChange={(event, newInputValue) => {console.log('onInputChange',event, newInputValue);
                        setDescriptionInputValue(newInputValue);
                        if (newInputValue !== undefined && newInputValue !== null) {
                            updateDescription(newInputValue);
                        }
                      }}
                      onChange={(event, value) => {
                        if (value !== undefined && value !== null) {
                            updateDescription(value.value);
                        }
                        else  {
                            updateDescription('');
                        }
                      }}
                      value={descriptionValue}
                      open={descriptionOptionsOpen}
                      onOpen={() => {
                        setDescriptionOptionsOpen(true);
                      }}
                      onClose={() => {
                        setDescriptionOptionsOpen(false);
                      }}
                      renderInput={(params) => <TextField
                            {...params}
                            label="Description"
                            variant="outlined"
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <Fragment>
                                  {descriptionOptionsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </Fragment>
                              ),
                            }}
                          />}
                    />

                    <TextField
                      id="serial"
                      disabled={!assetEditRole}
                      label="Serial"
                      autoComplete='off'
                      onChange={handleChange}
                      name="serial"
                      value={asset.serial || ''}
                      variant="outlined"
                      size="small"
                      style={{ marginBottom: 20 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ViewWeekIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                </div>

                <div className={classes.inline}>
                    <TextField
                      id="make"
                      disabled={!assetEditRole}
                      label="Make"
                      autoComplete='off'
                      onChange={handleChange}
                      name="make"
                      value={asset.make || ''}
                      variant="outlined"
                      size="small"
                      style={{ marginBottom: 20 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <BuildIcon />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <TextField
                      id="model"
                      disabled={!assetEditRole}
                      label="Model"
                      autoComplete='off'
                      onChange={handleChange}
                      name="model"
                      value={asset.model || ''}
                      variant="outlined"
                      size="small"
                      style={{ marginBottom: 20 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ShortTextIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                </div>

                <TextField
                  id="notes"
                  name="notes"
                  label="Notes"
                  autoComplete='off'
                  value={asset.notes || ''}
                  multiline
                  disabled
                  rows="5"
                  variant="outlined"
                  onChange={handleChange}
                  size="small"
                  style={{ marginBottom: 20 }}
                  InputProps={{
                    className: classes.textarea,
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />


                <div className={classes.inline} style={{marginBottom: 20}}>
                        <TextField
                          disabled
                          id="tested"
                          ref={testedRef}
                          label="Tested"
                          className={classnames({
                          'textField': true,
                          'calenderField': true,
                          [classes.calendarFocused]: testedFocused
                        })}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CalendarTodayIcon />
                                </InputAdornment>
                              ),
                              inputComponent: () =>
                              <DatePicker
                              disabled
                              ref={testedCalendarRef}
                              className={classes.textField}
                              selected={selectedTested}
                              onSelect={handleSelectTested}
                              onChange={handleChangeTested}
                              onFocus={focusTested}
                              onClickOutside={blurTested}
                              onKeyDown={handleTestedKeyPress}
                              locale="en-NZ"
                              timeIntervals={30}
                              dateFormat="dd/MM/yyyy"
                              />
                            }}
                            />


                        <TextField
                          disabled
                          id="expires"
                          ref={expiresRef}
                          label="Expires"
                          className={classnames({
                          'textField': true,
                          'calenderField': true,
                          [classes.calendarFocused]: expiresFocused
                        })}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CalendarTodayIcon />
                                </InputAdornment>
                              ),
                              inputComponent: () =>
                              <DatePicker
                              disabled
                              ref={expiresCalendarRef}
                              className={classes.textField}
                              selected={selectedExpires}
                              onSelect={handleSelectExpires}
                              onChange={handleChangeExpires}
                              onFocus={focusExpires}
                              onClickOutside={blurExpires}
                              onKeyDown={handleExpiresKeyPress}
                              locale="en-NZ"
                              timeIntervals={30}
                              dateFormat="dd/MM/yyyy"
                              />
                            }}
                            />

               </div>

                <Box display={"flex"} alignItems={"center"} style={{ marginBottom: 20 }}>
                    <Typography weight={"medium"}>
                        Disposed
                    </Typography>
                    <Switch color={"primary"} checked={asset.disposed}
                            onClick={onClickDisposedSwitch} />
                </Box>

                { asset.disposed !== undefined && asset.disposed !== null && asset.disposed &&
                  <div className={classes.inline}>
                  <div>
                    <FormControl variant="outlined"
                                  className={classnames({
                                    [classes.error]: noDisposalCodeSelectedError,
                                    'select-control': true
                                  })}>
                      <InputLabel id="region">Disposal Codes<sup>*</sup></InputLabel>
                      <div className={classnames({
                                    [classes.error]: noDisposalCodeSelectedError,
                                    'select-control-input': true
                                  })}>
                        <InputAdornment position="start">
                          <ConfirmationNumberIcon />
                        </InputAdornment>
                        <NativeSelect
                          value={selectedDisposalCodeCode}
                          onChange={handleChangeDisposalCode}
                          onBlur={onBlurDisposalCodeSelection}
                        >
                           {disposalCodesOptions}
                        </NativeSelect>
                      </div>
                      {noDisposalCodeSelectedError && <FormHelperText className={classes.error}>You must select a disposal code!</FormHelperText>}
                    </FormControl>
                  </div>


                    <TextField
                      id="disposal_date"
                      ref={disposalDateRef}
                      label="Disposal Date"
                      required
                      error={asset.disposal_code === undefined || asset.disposal_code === null || asset.disposal_code <= 0}
                      helperText={asset.disposal_code === undefined || asset.disposal_code === null || asset.disposal_code <= 0 ? 'Please select a disposal code.' : ' '}
                      className={classnames({
                      'textField': true,
                      'calenderField': true,
                      [classes.calendarFocused]: disposalDateFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={disposalDateCalendarRef}
                          className={classes.textField}
                          selected={selectedDisposalDate}
                          onSelect={handleSelectDisposalDate}
                          onChange={handleChangeDisposalDate}
                          onFocus={focusDisposalDate}
                          onClickOutside={blurDisposalDate}
                          onKeyDown={handleDisposalDateKeyPress}
                          locale="en-NZ"
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy"
                          />
                        }}
                        />

                </div>}

                {asset.custom_properties !== null && asset.custom_properties !== undefined  &&
                      <div style={{ marginBottom: '20px', fontSize:'16px' }}>
                        {Object.entries(asset.custom_properties).map(([key, value]) => (
                          <div key={key} >
                            <strong>{key}</strong>: {value}
                          </div>
                        ))}
                    </div>}

                  <div className={classes.readableResults} hidden={isFormtab}>
                      <h3>Detailed Test Results:</h3>
                      <div hidden={isReadableResultsLoaded}><CircularProgress color="inherit" size={20} /></div>
                      <div hidden={!isReadableResultsLoaded}>
                          <div hidden={!testerType || testerType.includes('Metrel')}>
                            Cannot display old Seaward Tester's detailed test results. Please request <a href="mailto: customer.service@testntel.co.nz">customer.service@testntel.co.nz</a>
                          </div>
                          <div hidden={!(!testerType || testerType.includes('Metrel'))}>
                              <div dangerouslySetInnerHTML={{__html:  readableResults}}></div>
                          </div>
                      </div>
                  </div>

              </div>
          </Grid>
        </Grid>
    </div></>
  );
//}
});
export default UpdateAsset;
